export default "__VITE_ASSET__ba74ec6b__"